
export default {
  email:null,
  id_cidadao:null,
  status:null,
  nome:null,
  numero_em_espera: 0, 
}
